import list from '@/modules/service/store/modules/list';

export default {
    namespaced: true,
    state: {},
    actions: {},
    getters: {},
    mutations: {},
    modules: {
        list
    }
};
